import { render, staticRenderFns } from "./ChartEdit.vue?vue&type=template&id=82061cc4&scoped=true"
import script from "./ChartEdit.vue?vue&type=script&lang=js"
export * from "./ChartEdit.vue?vue&type=script&lang=js"
import style0 from "./ChartEdit.vue?vue&type=style&index=0&id=82061cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82061cc4",
  null
  
)

export default component.exports